import React from 'react';
import { XMarkIcon, ArrowDownTrayIcon } from '@heroicons/react/24/outline';

interface ImageViewerProps {
  isOpen: boolean;
  onClose: () => void;
  imageUrl: string;
  caption?: string;
  filename?: string;
}

const ImageViewer: React.FC<ImageViewerProps> = ({ 
  isOpen, 
  onClose, 
  imageUrl, 
  caption,
  filename
}) => {
  if (!isOpen) return null;

  const handleDownload = () => {
    const link = document.createElement('a');
    link.href = imageUrl;
    link.download = filename || 'image';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div 
      className="fixed inset-0 bg-black bg-opacity-90 flex flex-col justify-center items-center z-50 p-4"
      onClick={onClose}
      role="dialog"
      aria-modal="true"
    >
      <div className="absolute top-4 right-4 flex gap-2">
        <button 
          onClick={(e) => {
            e.stopPropagation();
            handleDownload();
          }}
          className="text-white bg-gray-800 rounded-full p-2 hover:bg-gray-700"
          title="Скачать изображение"
        >
          <ArrowDownTrayIcon className="h-6 w-6" />
        </button>
        <button 
          onClick={onClose}
          className="text-white bg-gray-800 rounded-full p-2 hover:bg-gray-700"
          title="Закрыть"
        >
          <XMarkIcon className="h-6 w-6" />
        </button>
      </div>
      
      <div 
        className="max-h-[90vh] max-w-[90vw] flex items-center justify-center"
        onClick={(e) => e.stopPropagation()}
      >
        <img 
          src={imageUrl} 
          alt={caption || "Просмотр изображения"} 
          className="max-h-[90vh] max-w-[90vw] object-contain"
        />
      </div>
      
      {caption && (
        <div 
          className="mt-4 bg-gray-800 text-white p-3 rounded-lg max-w-xl text-center"
          onClick={(e) => e.stopPropagation()}
        >
          {caption}
        </div>
      )}
    </div>
  );
};

export default ImageViewer;
